import { PartnerHashList } from 'types/general';
import request from '../../../lib/helpers/requestApi';
import { TOffersList } from './types';

export const getOffersListAPI = request<TOffersList, Partial<PartnerHashList>>({
  method: 'offer.getList',
});
